import { createTheme, Theme } from '@mui/material'

// GRTable header cells have no horizontal padding while its body cells have 0.75em, which sortable headers get back from their sort label.
const bodyAlignedHeaderPadding = {
  '&.HeaderCell.MuiTableCell-alignLeft:not(:has(.MuiTableSortLabel-root))': { paddingLeft: '0.75em' },
  '&.HeaderCell.MuiTableCell-alignRight:not(:has(.MuiTableSortLabel-root))': { paddingRight: '0.75em' },
}

/**
 * Theme options for internal tools. This theme will __extend__ the current theme.
 */
export const internalTheme = (theme: Theme) =>
  createTheme({
    ...theme,
    components: {
      ...theme.components,
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '0.875rem',
          },
          head: {
            fontSize: '0.875rem',
            fontWeight: 700,
            color: theme.palette.text.primary,
            ...bodyAlignedHeaderPadding,
          },
        },
      },
    },
  })
